import {NgModule} from "@angular/core";
import {CommonModule as NgCommonModule} from "@angular/common";
import {RouterModule, Routes} from "@angular/router";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AgmCoreModule} from "@agm/core";
import {AgmJsMarkerClustererModule} from "@agm/js-marker-clusterer";
import { TranslateModule } from '@ngx-translate/core';
import { CodeInputModule } from 'angular-code-input';

import {HomeComponent} from "./home/home.component";
import {BranchesComponent} from "./map-branches/branches-component/branches-component.component";
import {PostalComponent} from "./postal-codes/posta-component.component";
import {AnkesaComponent} from "./ankesa/ankesa.component";
import {NotificationComponent} from "./notifications/notification.component";
import {CommonModule} from "../common/common.module";
import {AuthGuardService as AuthGuard} from "../services/auth-guard";
import {TermsOfUseComponent} from "./terms-of-use/terms-of-use.component";
import {PrivacyComponent} from "./privacy/privacy.component";
import {AccountDeletionComponent} from "./account-deletion/account-deletion.component";
import {ServiceContractComponent as Personal} from "./service-contract/service-contract-personal.component";
import {ServiceContractComponent as Business} from "./service-contract/service-contract-business.component";
import {RegisterComponent} from "./register/register.component"
import {MyContractsComponent} from "./mycontracts/myContracts.component";
import {TransactionProgressComponent} from "./transaction-progress/transaction-progress.component";
import {TransactionHistoryComponent} from "./transaction-history/transaction-history.component";
import {TransfersComponent} from "./transfers/transfers.component";
import {WalletListComponent} from "./home/wallet-list/wallet-list.component";
import {ChipsSearchComponent} from "./mycontracts/chips-search/chips-search.component";
import {ChipComponent} from "./mycontracts/chip/chip.component";
import {InputSelectComponent} from "./mycontracts/input-select/input-select.component";
import { CancelComponent } from "./creditcard/cancel/cancel.component";
import { SuccessComponent } from "./creditcard/success/success.component";
import { ErrorComponent } from "./creditcard/error/error.component";
// sldb pages
import { DepositComponent } from "./deposits/deposit.component"
import { LoanComponent } from "./loans/loan.component";
import { AccountComponent } from "./accounts/account.component";
import { TransferComponent } from "./transfer/transfer-mobile-ui.component";
import { TransferHistoryComponent } from "./transfer-history/transfer-history.component";
import { MessageComponent } from "./messages/message.component";
import { CreateMessageComponent } from "./messages/create-message/create-message.component";
import { MessageDetailComponent } from "./messages/message-detail/message-detail.component";
import { LoanEnquireComponent } from "./loan-enquire/loan-enquire.component";
import { CreateLoanEnquireComponent } from "./loan-enquire/create-loan-enquire/create-loan-enquire.component";
import { environment } from "src/environments/environment";

const staticRoutes: Routes = [
    {path: "", component: HomeComponent},
    {path: "transaction-progress", component: TransactionProgressComponent},
    {path: "privacy-policy", component: PrivacyComponent},
    {path: "account-deletion", component: AccountDeletionComponent},
    {path: "terms-of-use", component: TermsOfUseComponent},
    {path: "cancel", component: CancelComponent},
    {path: "success", component: SuccessComponent},
    {path: "error", component: ErrorComponent},
    {path: "service-contract-personal", component: Personal},
    {path: "service-contract-business", component: Business},
    {path: "register", component: RegisterComponent, canActivate: [AuthGuard]},
    {path: "ankesa", component: AnkesaComponent, canActivate: [AuthGuard]},
    {path: "my-contracts", component: MyContractsComponent, canActivate: [AuthGuard]},
    {path: "transaction-history", component: TransactionHistoryComponent, canActivate: [AuthGuard]},
    {path: "transfers", component: TransfersComponent, canActivate: [AuthGuard]},
    {path: "profile/notifications", component: NotificationComponent, canActivate: [AuthGuard]},
    {path: "deposits", component: DepositComponent, canActivate: [AuthGuard]},
    {path: "loans", component: LoanComponent, canActivate: [AuthGuard]},
    {path: "accounts", component: AccountComponent, canActivate: [AuthGuard]},
    {path: "branches", component: BranchesComponent, canActivate: [AuthGuard]},
    {path: "postalcodes", component: PostalComponent, canActivate: [AuthGuard]},
    {path: "transfer", component: TransferComponent, canActivate: [AuthGuard]},
    {path: "transfer-history", component: TransferHistoryComponent, canActivate: [AuthGuard]},
    {path: "messages", component: MessageComponent, canActivate: [AuthGuard]},
    {path: "create-message", component: CreateMessageComponent, canActivate: [AuthGuard]},
    {path: "messages/:messageId", component: MessageDetailComponent, canActivate: [AuthGuard] },
    {path: "loan-enquires", component: LoanEnquireComponent, canActivate: [AuthGuard] },
    {path: "create-loan-enquire", component: CreateLoanEnquireComponent, canActivate: [AuthGuard] },
];

let routes = staticRoutes;

// if (environment.showAnkesa) {
//   routes = routes.concat({ path: "ankesa", component: AnkesaComponent })
// }

// if (environment.showMyContract) {
//   routes = routes.concat({ path: "my-contracts", component: MyContractsComponent, canActivate: [AuthGuard] })
// }

// if (environment.showTransactionHistory) {
//   routes = routes.concat({ path: "transaction-history", component: TransactionHistoryComponent, canActivate: [AuthGuard] })
// }

// if (environment.showTransferAnnouncement) {
//   routes = routes.concat({ path: "transfers", component: TransfersComponent, canActivate: [AuthGuard] })
// }

// if (environment.showNotification) {
//   routes = routes.concat({ path: "profile/notifications", component: NotificationComponent, canActivate: [AuthGuard] })
// }

// if (environment.showDeposits) {
//   routes = routes.concat({ path: "deposits", component: DepositComponent, canActivate: [AuthGuard] })
// }

// if (environment.showLoans) {
//   routes = routes.concat({ path: "loans", component: LoanComponent, canActivate: [AuthGuard] })
// }

// if (environment.showAccounts) {
//   routes = routes.concat({ path: "accounts", component: AccountComponent, canActivate: [AuthGuard] })
// }

// if (environment.showBranches) {
//   routes = routes.concat({ path: "branches", component: BranchesComponent })
// }

// if (environment.showPostalCode) {
//   routes = routes.concat({ path: "postalcodes", component: PostalComponent })
// }

// if (environment.showTransfers) {
//   routes = routes.concat({ path: "transfer", component: TransferComponent, canActivate: [AuthGuard] })
// }

// if (environment.showTransferHistory) {
//   routes = routes.concat({ path: "transfer-history", component: TransferHistoryComponent, canActivate: [AuthGuard] })
// }

// if (environment.showMessage) {
//   routes = routes.concat({ path: "messages", component: MessageComponent, canActivate: [AuthGuard] })
// }
@NgModule({
    imports: [
        RouterModule,
        NgCommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule.forRoot(routes),
        CommonModule,

        AgmCoreModule.forRoot({
            apiKey: "AIzaSyBVVkngkbIiUK0gjBZWKJm8wQBN4onorP4"
        }),
        AgmJsMarkerClustererModule,
        TranslateModule,
        CodeInputModule.forRoot({
          codeLength: 6,
          code: ""
        }),
    ],
    declarations: [
        HomeComponent,
        BranchesComponent,
        PostalComponent,
        AnkesaComponent,
        NotificationComponent,
        MyContractsComponent,
        TransactionProgressComponent,
        TransactionHistoryComponent,
        PrivacyComponent,
        AccountDeletionComponent,
        TermsOfUseComponent,
        CancelComponent,
        SuccessComponent,
        ErrorComponent,
        Personal,
        Business,
        RegisterComponent,
        TransfersComponent,
        WalletListComponent,
        ChipsSearchComponent,
        ChipComponent,
        InputSelectComponent,
        DepositComponent,
        LoanComponent,
        AccountComponent,
        TransferComponent,
        TransferHistoryComponent,
        MessageComponent,
        CreateMessageComponent,
        MessageDetailComponent,
        LoanEnquireComponent,
        CreateLoanEnquireComponent
    ],
    exports: [
      TranslateModule
    ]

})

export class MainPagesModule {
}


